import type { PremiumActivityByAudience } from '@/api/lms/library'
import type { VisibilityTag } from '@/api/lms/organizations'
import type { REQUEST_STATUS } from '@/legacy/redux/types/status'
import type { Book as BookContentCreator } from '@/sections/content-creator/books/types/books'
import type { Tag } from '@/sections/content-creator/sequenceDrawer/types/books'
import type {
  GetAllTagsFailure,
  GetAllTagsRequest,
  GetAllTagsSuccess,
  LibraryResourceTagCategory,
} from './libraryBooks'

export interface BooksDrawerState {
  isOpen: boolean
  currentStep: BOOKS_DRAWER_STEPS
  selectedBook: Book
  tags: {
    list: LibraryResourceTagCategory[]
    error: string
    status: REQUEST_STATUS
  }
  activities: {
    selected: PremiumActivityByAudience[]
    count: number
    status: REQUEST_STATUS
    error: string
  }
}

export interface Book extends BookContentCreator {
  tags: Tag[]
  visibilityTags: VisibilityTag[]
  amount: number
  organizationName: string
  organizationLogo: string
  audiences: { id: number; name: string }[]
}

export enum BOOKS_DRAWER_STEPS {
  DETAILS = 'DETAILS',
  ACTIVITIES = 'ACTIVITIES',
}

export enum BOOKS_DRAWER_TYPES {
  SET_OPEN = 'TEACHER/BOOKS_DRAWER/SET_BOOK_OPEN',
  SET_CLOSE = 'TEACHER/BOOKS_DRAWER/SET_BOOK_CLOSE',
  SET_SELECTED_BOOK = 'TEACHER/BOOKS_DRAWER/SET_SELECTED_BOOK',
  SET_SELECTED_STEP = 'TEACHER/BOOKS_DRAWER/SET_SELECTED_STEP',
  GET_BOOK_ACTIVITIES_REQUEST = 'TEACHER/BOOKS_DRAWER/GET_BOOK_ACTIVITIES_REQUEST',
  GET_BOOK_ACTIVITIES_SUCCESS = 'TEACHER/BOOKS_DRAWER/GET_BOOK_ACTIVITIES_SUCCESS',
  GET_BOOK_ACTIVITIES_FAILURE = 'TEACHER/BOOKS_DRAWER/GET_BOOK_ACTIVITIES_FAILURE',
}

export type SetOpenBooksDrawerAction = {
  type: BOOKS_DRAWER_TYPES.SET_OPEN
}

export type SetCloseBooksDrawerAction = {
  type: BOOKS_DRAWER_TYPES.SET_CLOSE
}
export type SetSelectedBookAction = {
  type: BOOKS_DRAWER_TYPES.SET_SELECTED_BOOK
  payload: {
    book: Book
  }
}

export type SetSelectedStepAction = {
  type: BOOKS_DRAWER_TYPES.SET_SELECTED_STEP
  payload: {
    currentStep: BOOKS_DRAWER_STEPS
  }
}

export interface GetBookActivitiesRequest {
  type: BOOKS_DRAWER_TYPES.GET_BOOK_ACTIVITIES_REQUEST
  payload: {
    page: number
    rowsPerPage: number
  }
}

export interface GetBookActivitiesSuccess {
  type: BOOKS_DRAWER_TYPES.GET_BOOK_ACTIVITIES_SUCCESS
  payload: {
    bookActivities: PremiumActivityByAudience[]
    count: number
  }
}

export interface GetBookActivitiesFailure {
  type: BOOKS_DRAWER_TYPES.GET_BOOK_ACTIVITIES_FAILURE
  payload: {
    error: string
  }
}

export type BookDrawersActions =
  | SetOpenBooksDrawerAction
  | SetCloseBooksDrawerAction
  | SetSelectedBookAction
  | SetSelectedStepAction
  | GetAllTagsRequest
  | GetAllTagsSuccess
  | GetAllTagsFailure
  | GetBookActivitiesRequest
  | GetBookActivitiesSuccess
  | GetBookActivitiesFailure
